import { omitBy, isUndefined } from 'lodash';

import fillParams from '@/utils/params';

export default {
  provide() { return { $page: this }; },
  metaInfo() {
    // if (!this.$pageComponentRoute) return {};
    const { title } = this.$pageComponentRoute.meta;
    const meta = omitBy({
      title: title && this.$t(title),
    }, isUndefined);
    return meta;
  },
  beforeCreate() {
    const { matched, params } = this.$route;
    const { path } = matched.find(route => route.instances.default === this);
    const key = fillParams(path, params);

    this.$pageComponentRoute = this.$route;
    this.$pageComponentKey = key;
  },
  activated() { this.fetchData(); },
  computed: {
    $pageComponentNextKey() {
      const index = this.$route.matched.findIndex(route => route.instances.default === this);
      if (index === -1) return undefined;
      const route = this.$route.matched[index + 1];
      if (!route) return undefined;
      const { params } = this.$route;
      const path = fillParams(route.path, params);
      return path;
    },
  },
  methods: {
    fetchData() {},
  },
};
